import React, { useRef, useState } from "react";
import {
  InputField,
  SubmitButton,
  TextComponent,
  TextHeader,
} from "../../../../components";
import styles from "./RsvpFamily.module.css";
import addImage from "../../../../assets/staticImages/addImage.png";
import { Col, Row } from "antd";
import { AiFillPlusCircle } from "react-icons/ai";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { setRSVP } from "../../../../Store/Actions/EventPlanningActions";
const CloseIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 28 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.0773 23.0073L19.7087 15.0542L27.0775 7.10081L21.103 0.652335L13.7342 8.60568L6.36558 0.652567L0.390883 7.10123L7.75946 15.0543L0.390667 23.0077L6.36519 29.4562L13.734 21.5028L21.1026 29.4559L27.0773 23.0073Z"
      fill="#ED73AA"
    />
  </svg>
);

const RenderItem = ({ item, index, setFamilyArray, FamilyArray }) => {
  const handleInput = useRef();
  const handleImageClick = () => {
    handleInput.current.click();
  };
  console.log(item.image);
  return (
    <div style={{ marginTop: "20px" }} key={index.toString()}>
      <Row gutter={[16, 16]} className={styles.innerContainer}>
        <Col xs={24} sm={12} md={12} lg={11} className={styles.innerDiv}>
          <InputField
            label="Name"
            rightIcon={CloseIcon}
            onRightIconPress={() => {
              let array = [...FamilyArray];
              if (array.length == 1) return;
              array.splice(index, 1);
              setFamilyArray(array);
            }}
            onChange={(e) => {
              let array = [...FamilyArray];
              array[index].name = e.target.value;
              setFamilyArray(array);
            }}
            value={item.name}
            placeholder={"Add Name"}
          />
          <InputField
            label="Category"
            onChange={(e) => {
              let array = [...FamilyArray];
              array[index].category = e.target.value;
              setFamilyArray(array);
            }}
            value={item.category}
            placeholder={"Add category"}
          />
        </Col>
        <Col xs={24} sm={12} md={11} lg={12} className={styles.innerDiv1}>
          <div onClick={handleImageClick}>
            <img
              // style={{ width: 300, height: 300 }}
              src={
                item?.image?.size ? URL?.createObjectURL(item?.image) : addImage
              }
              alt="image"
              className={styles.image}
            />
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                // setGalleryImg(e.target.files[0]);
                let data = [...FamilyArray];
                data[index].image = e.target.files[0];
                setFamilyArray(data);
              }}
              ref={handleInput}
              style={{ display: "none" }}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

const RsvpFamily = () => {
  const handleInput = useRef();
  const [galleryImg, setGalleryImg] = useState();
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const { state } = useLocation();
  const eventData = state?.eventData;
  const dispatch = useDispatch();
  const [FamilyArray, setFamilyArray] = useState(
    RSVP?.family?.length > 0
      ? RSVP?.family
      : [
          {
            name: "",
            category: "",
            image: null,
          },
        ]
  );
  console.log("FamilyArray", FamilyArray);
  const next = () => {
    let data = [...FamilyArray];
    if (
      !data[data.length - 1].name ||
      !data[data.length - 1].category ||
      !data[data.length - 1].image?.size
    ) {
      dispatch(
        showAlert({
          type: "Error",
          title: "Family",
          message: "Please fill all family details.!",
          status: 400,
        })
      );
      return;
    } else {
      let resdata = {
        ...RSVP,
        family: FamilyArray,
      };
      dispatch(setRSVP(resdata));
      navigate("/events/rsvp/rsvpaddress", {
        state: { headrTitle: "RSVP", eventData: eventData },
      });
    }
  };

  const navigate = useNavigate();
  return (
    <div>
      <TextHeader
        text={"6. Family Picture"}
        containerClass={styles.textContainer}
        textClass={styles.textHeading}
      />
      {FamilyArray?.map((item, index) => {
        return (
          <RenderItem
            item={item}
            index={index}
            setFamilyArray={setFamilyArray}
            FamilyArray={FamilyArray}
          />
        );
      })}

      <div
        className={styles.innerContainer1}
        onClick={() => {
          let data = [...FamilyArray];
          if (!data[data.length - 1].name || !data[data.length - 1].category) {
            dispatch(
              showAlert({
                type: "Error",
                title: "Family",
                message: "Please fill all family details.!",
                status: 400,
              })
            );
            return;
          }
          data.push({
            name: "",
            category: "",
            image: null,
          });
          setFamilyArray(data);
        }}
      >
        <AiFillPlusCircle className={styles.icon} size={40} />
        <TextComponent text={"Add Picture"} textClass={styles.innertext} />
      </div>

      <Row gutter={[16, 16]} className={styles.btnRow}>
        <Col xs={24} sm={12} md={10} lg={8} xl={7}>
          <SubmitButton
            btnClass={styles.btnClass}
            title="Next"
            onClick={next}
          />
        </Col>
      </Row>
    </div>
  );
};

export default RsvpFamily;
